<template name="u-select">
  <div>
	  <van-field
		  v-bind="$attrs"
          @click="show = true"
		 :value="name"
		 :placeholder="placeholder"
        />
	
	   <van-action-sheet
          v-model="show"
          :actions="dataList"
          @select="onSelect"
          close-on-click-action
          cancel-text="取消"
        /> 
  </div>		
</template>

<script>
	/**
	 * input 选择框 
	 * 不要直接引用父组件传过来的值，可以把接收到的父组件的值赋值给一个新的参数
	 * 1.加入页面传入url,和请求参数。
	 * 2.看是否加入选择后得回调。
	 * @description 
	 */
	import { getAction, postAction ,postParam } from '@/api/manage'
	export default {
			name: 'u-select',
			props: {
				value:{
					type:String,
					default:""
				},
				placeholder: {
					type: String,
					default: '请选择'
				},
				list:{
					type: Array,
					default() {
						return []
					}
				},
				ifNetData: {
					type: Boolean,
					default: true
				},
				defValue:{
					type:String,
					default:""
				},
				dictCode: String,
			},
			created(){
			  if(this.ifNetData){
				  this.getData();	
				}
			},
		// 	computed: {
		// 	_attrs() {
		// 		let attrs = { ...this.$attrs };
		// 		return attrs;
		// 	},
	    //    },
			data() {
				return {
				   show:false,
				   dataList:this.list,
				   name:"",
				   myValue:this.value,
				   
				}
			},
			watch: {
			  list: {
			  	immediate: true,
			  	handler() {
			  		this.dataList = this.list;
			  	},
			  },
			  defValue: {
			  	immediate: true,
			  	handler() {
			  		this.name = this.defValue;
			  	},
			  },
			  myValue (newVal) {
			    this.$emit('input', newVal)
			  },
			  },
			methods: {
				  onSelect(item) {
					this.show = false
					this.name = item.name;
					this.myValue  = item.value;
					 this.$emit('selectConfirm',item);
					},
			    /**
				 * 公司获取字典值得url
				 */
				getData(){
					let url = `/sys/dict/getDictItems/${this.dictCode}`;
						getAction(url)
						.then((res) => {
							if(res.success){
                              let list = res.result;
							  list.map(obj=>{
								obj.name = obj.title;
								return obj;
							  })
							  this.dataList = list;
							}
							 
						})
				}
			}
		}
</script>

<style lang="scss" scoped>
	
	
	
	
	
	
	
</style>
